import * as utility from '../misc/utility';

export enum AttachmentType {
    Unspecified = 0,
    ClaimGenericReceipt = 1,
    ClaimParkingReceipt = 2,
    ClaimPublicTransportReceipt = 3,
    ClaimCongestionSpecification = 4,
    ClaimSalarySpecification = 5,
    ClaimEmployerTestimony = 6,
    ProfilePhoto = 7,
    Folder = 8,
    File = 9,
};

export function getAttachmentTypeName(attachmentType: AttachmentType) {
    switch (attachmentType) {
        case 0: return 'Bilaga';
        case 1: return 'Kvitto';
        case 2: return 'Kvitto - Parkering';
        case 3: return 'Kvitto - Kollektivtrafik';
        case 4: return 'Kvitto - Trängselskatt';
        case 5: return 'Lönespecifikation';
        case 6: return 'Arbetsgivarintyg';
        default: return 'Bilaga';
    }
}

export interface IAttachmentInfo {
    Id: string;
    AttachmentType: number;
    Filename: string;
    Description: string;
    CreatedTimestamp: string;
}

export class AttachmentInfo {
    Id: string;
    AttachmentType: AttachmentType;
    Filename: string;
    Description: string;
    CreatedTimestamp: Date;

    constructor(src: IAttachmentInfo) {
        this.Id = src.Id;
        this.AttachmentType = src.AttachmentType;
        this.Filename = src.Filename;
        this.Description = src.Description;
        this.CreatedTimestamp = utility.parseRequiredDate(src.CreatedTimestamp);
    }
}
